
import { COMPILER_OPTIONS, CompilerFactory, Compiler, NgModule, ElementRef, NgZone } from '@angular/core';
import { JitCompilerFactory } from '@angular/platform-browser-dynamic';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { LazyLoadingService } from './common/lazyloading';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule, Routes, RouterOutlet,provideRoutes } from '@angular/router';
//import { AppComponent } from './app.component';
//Dev Extreme Imports

import { DxTextAreaModule } from 'devextreme-angular/ui/text-area';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';


//Dev Extreme Imports
import { DxTreeViewModule } from 'devextreme-angular/ui/tree-view';
import { DxButtonModule } from 'devextreme-angular/ui/button'
import { DxLoadPanelModule } from 'devextreme-angular/ui/load-panel';
import { DxPopupModule } from 'devextreme-angular/ui/popup';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
//import { DxTreeListModule } from 'devextreme-angular/ui/tree-list';
//import { DxSwitchModule } from 'devextreme-angular/ui/switch';
//Main App Routing Module
import { AppRoutingModule } from './app-routing.module';



//Main Bootstrap Component Import
import { DashboardappComponent } from '../app/DashBoardManagement/dashboardapp/dashboardapp.component';
import { AppComponent } from '../app/app.component';

//import { parse } from 'papaparse';
import { LoggerService } from './common/LoggerService/logger.service';
import { ConsoleLoggerService } from './common/LoggerService/console-logger.service';

// Import all Froala Editor plugins.
import "froala-editor/js/froala_editor.pkgd.min.js";
import 'froala-editor/js/plugins.pkgd.min.js';
import { AuthInterceptor } from './authentication.service';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';


@NgModule({ declarations: [AppComponent],
    bootstrap: [DashboardappComponent], imports: [FroalaEditorModule.forRoot(), FroalaViewModule.forRoot(),
        RouterModule,
        BrowserModule,
        FormsModule,
        DxButtonModule,
        DxDataGridModule,
        AppRoutingModule,
        DxTextAreaModule,
        DxTextBoxModule,
        //Dev extreme modules required by the bootstrapped - DashboardappComponent
        DxTreeViewModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxTextBoxModule,
        DxPopupModule,
        DxTextAreaModule,
        NoopAnimationsModule
        //parse
    ], providers: [DatePipe, LazyLoadingService, { provide: LoggerService, useClass: ConsoleLoggerService },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: COMPILER_OPTIONS, useValue: {}, multi: true },
        {
            provide: CompilerFactory,
            useClass: JitCompilerFactory,
            deps: [COMPILER_OPTIONS]
        }, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
